export default __webpack_public_path__ + "static/media/updatesSecBg.52e101e1.png";